module.exports = __webpack_public_path__ + "static/media/WW2-Europe.edf86283.jpg";